import TagsInput from 'react-tagsinput';
import AutosizeInput from 'react-input-autosize';

import { isEmail } from 'utils';

import { Label } from 'styles/modals';
import { CloseButton, EmailBoxContainer } from './styles';

function autosizingRenderInput({ ...props }) {
  return <AutosizeInput type="text" {...props} />;
}

function defaultRenderTag(props) {
  const { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;

  return (
    <span key={key} className={isEmail(tag) ? '' : 'invalid-format'}>
      <span {...other}>
        {getTagDisplayValue(tag)}
        {!disabled && <CloseButton className={classNameRemove} onClick={getRemoveHander(onRemove, key)} />}
      </span>
    </span>
  );
}

function getRemoveHander(onRemove, key) {
  return function () {
    onRemove(key);
  };
}

const EmailsBox = (props) => {
  if (!props.visible) {
    return null;
  }

  return (
    <EmailBoxContainer>
      <Label>{props.label}</Label>
      <TagsInput
        value={props.emails}
        addKeys={[9, 13, 32, 188]} // Tab, Enter, Space, Comma
        onChange={props.onChangeEmails}
        inputProps={{ placeholder: '' }}
        renderInput={autosizingRenderInput}
        renderTag={defaultRenderTag}
        addOnBlur
        addOnPaste
      />
    </EmailBoxContainer>
  );
};

export default EmailsBox;
